import { Reveal } from "@/components/common/Reveal";

/** Consistent section heading with eyebrow, title and optional intro. */
export default function SectionHeading({ eyebrow, title, intro, align = "left", light = false }) {
  const alignCls = align === "center" ? "mx-auto text-center items-center" : "items-start";
  return (
    <Reveal className={`flex max-w-2xl flex-col ${alignCls}`}>
      {eyebrow && (
        <span className={`text-xs font-semibold uppercase tracking-[0.2em] ${light ? "text-brand-red-light" : "text-brand-red"}`}>
          {eyebrow}
        </span>
      )}
      <h2 className={`mt-3 font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1] ${light ? "text-white" : "text-brand-blue"}`}>
        {title}
      </h2>
      {intro && (
        <p className={`mt-4 text-base leading-relaxed ${light ? "text-white/70" : "text-slate-500"}`}>{intro}</p>
      )}
    </Reveal>
  );
}
